import { render } from "./STRLogo.vue?vue&type=template&id=ef696c34"
import script from "./STRLogo.vue?vue&type=script&lang=js"
export * from "./STRLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__